export default __webpack_public_path__ + "static/media/tri-top.03e8ad36.svg";